const slides = {
  addSlide: "Add Slide",
  deleteSlide: "Delete Slide",
  duplicateSlide: "Duplicate Slide",
  addText: "Add Text",
  addImage: "Add Image",
  addShape: "Add Shape",
  present: "Present",
  exitPresentation: "Exit Presentation",
  slideOf: "Slide {current} of {total}",
  fontFamily: "Font",
  fontSize: "Font Size",
  fillColor: "Fill Color",
  borderColor: "Border Color",
  bringForward: "Bring Forward",
  sendBackward: "Send Backward",
  deleteElement: "Delete Element",
  rectangle: "Rectangle",
  circle: "Circle",
  arrow: "Arrow",
  line: "Line",
  untitled: "Untitled Presentation",
} as const;
export default slides;
